<template>
  <div>
    <div class="router-content page-right-header">
      <vs-button color="primary" type="filled" @click="showAddEditDialog = true"
        >Add Branch</vs-button
      >
    </div>
    <vs-popup
      class="holamundo digitelex-popup"
      :title="modalTitle"
      :active.sync="showAddEditDialog"
    >
      <addEditBranch
        :frmData="currentEditRow ? currentEditRow : formData"
        v-if="showAddEditDialog"
        @submitResponse="reloadData"
      ></addEditBranch>
    </vs-popup>
    <div id="ag-grid-demo">
      <vx-card>
        <!-- TABLE ACTION ROW -->
        <div class="flex flex-wrap justify-between items-center">
          <!-- ITEMS PER PAGE -->
          <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="
                  p-4
                  border border-solid
                  d-theme-border-grey-light
                  rounded-full
                  d-theme-dark-bg
                  cursor-pointer
                  flex
                  items-center
                  justify-between
                  font-medium
                "
              >
                <span class="mr-2">
                  {{
                    currentPage * paginationPageSize - (paginationPageSize - 1)
                  }}
                  -
                  {{
                    branches.length - currentPage * paginationPageSize > 0
                      ? currentPage * paginationPageSize
                      : branches.length
                  }}
                  of {{ branches.length }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                  <span>150</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <div
            class="
              flex flex-wrap
              items-center
              justify-between
              ag-grid-table-actions-right
            "
          >
            <vs-input
              class="mb-4 md:mb-0 mr-4"
              v-model="searchQuery"
              @input="updateSearchQuery"
              placeholder="Search..."
            />
            <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()"
              >Export as CSV</vs-button
            >
          </div>
        </div>
        <ag-grid-vue
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="branches"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :context="context"
          :tooltipShowDelay="'0'"
          :overlayLoadingTemplate="overlayLoadingTemplate"
          :overlayNoRowsTemplate="overlayNoRowsTemplate"
        ></ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="maxPageNumbers"
          v-model="currentPage"
        />
      </vx-card>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { EventBus } from "./../../../utils/grid/eventbus.js";
import addEditBranch from "./add-edit-branch";

// define cellRenderer to be reused
//  @close="close" -> For popup props
let actionsTemplate = {
  template: `<div class="flex">
      <vs-button class="w-1/2 h-12 flex"  @click="editBranch" size="large"radius color="primary" type="flat" icon-pack="feather" icon="icon-edit"></vs-button>
      <vs-button class="w-1/2 h-12 flex" @click="deleteBranch" size="large"radius color="danger" type="flat" icon-pack="feather" icon="icon-trash"></vs-button>
    </div>`,
  methods: {
    editBranch() {
      EventBus.$emit("editBranch", { item: this.params });
    },
    deleteBranch() {
      EventBus.$emit("deleteBranch", { item: this.params });
    },
  },
  beforeMount() {},
};
export default {
  components: {
    "ag-grid-vue": AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    actionsTemplate: actionsTemplate,
    addEditBranch: addEditBranch,
  },
  beforeMount() {
    //
    this.overlayLoadingTemplate =
      '<span class="ag-overlay-loading-center">Please wait while loading Branch</span>';
    this.overlayNoRowsTemplate =
      '<span class="ag-overlay-loading-center">No Branches found!</span>';
    this.context = {
      componentParent: this,
    };
  },
  data() {
    return {
      showAddEditDialog: false,
      currentEditRow: null,
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      context: null,
      modalTitle: "Add Branch",
      formData: {
        isActive: true,
        branchName: "",
        locationId: -1,
        email: "",
        mobileNo: null,
        manager: "",
        managerMobileNo: null,
        branchTypeId: -1,
        branchId: 0,
      },
      overlayLoadingTemplate: null,
      overlayNoRowsTemplate: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: "Actions",
          width: 150,
          filter: false,
          pinned: "left",
          cellRendererFramework: "actionsTemplate",
        },
        {
          headerName: "Branch Name",
          field: "branchName",
          width: 200,
          filter: true,
          tooltipField: "branchName",
          pinned: "left",
        },
        {
          headerName: "Location",
          headerTooltip: "Location",
          field: "locationName",
          filter: true,
          width: 125,
          tooltipField: "locationName",
        },
        {
          headerName: "Email",
          headerTooltip: "Email",
          field: "email",
          filter: true,
          width: 200,
          tooltipField: "email",
        },
        {
          headerName: "Mobile No",
          field: "mobileNo",
          headerTooltip: "Mobile No",
          filter: true,
          width: 200,
          tooltipField: "mobileNo",
        },
        {
          headerName: "Manager Name",
          headerTooltip: "Manager Name",
          field: "manager",
          filter: true,
          width: 180,
          tooltipField: "manager",
        },
        {
          headerName: "Manager Mobile No",
          headerTooltip: "Manager Mobile No",
          field: "managerMobileNo",
          filter: true,
          width: 250,
          tooltipField: "managerMobileNo",
        },
        {
          headerName: "Branch Type",
          headerTooltip: "Branch Type",
          field: "branchTypeName",
          filter: true,
          width: 150,
          tooltipField: "branchTypeName",
        },
      ],
      branches: [],
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("clientName", null);
      } else this.gridOptions.columnApi.setColumnPinned("clientName", "left");
    },
    showAddEditDialog: function () {
      Object.keys(this.formData).forEach((key) => {
        if (typeof key === "string") this.formData[key] = "";
        else if (typeof key === "boolean") this.formData[key] = false;
        else if (typeof key === "number") this.formData[key] = 0;
        else this.formData[key] = "";
      });
      if (!this.showAddEditDialog) {
        this.currentEditRow = false;
      }
    },
  },
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    reloadData(_event) {
      this.showAddEditDialog = false;
      this.branches = _event.data.data;
      this.$vs.notify({
        title: _event.data.message,
        color: "success",
        position: "top-right",
      });
      this.gridApi.setRowData(_event.data.data);
    },
    deleteBranch(_e) {
      this.$http
        .put("common/branch", _e.data)
        .then((response) => {
          // text:'Lorem ipsum dolor sit amet, consectetur',

          this.$vs.notify({
            title: response.data.message,
            color: "success",
            position: "top-right",
          });
          this.gridApi.setRowData(response.data.data);
          // this.$emit("submitResponse", response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.showLoadingOverlay();
    this.$http.get("common/branches").then((response) => {
      if (response.data.data.length > 0) {
        this.gridApi.hideOverlay();
        this.branches = response.data.data;
      } else {
        this.gridApi.showNoRowsOverlay();
      }
    });
    EventBus.$on("editBranch", (branchData) => {
      this.currentEditRow = branchData.item.data;
      this.showAddEditDialog = true;
    });
    EventBus.$on("deleteBranch", (branchData) => {
      // this.currentEditRow = clientData.item.data;
      let rowData = branchData;
      rowData.item.data.isActive = false;
      console.log(branchData);
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Branch?`,
        text: ``,
        acceptText: "Accept!",
        accept: this.deleteBranch,
        parameters: rowData.item,
      });
      setTimeout(() => {
        if (document.getElementsByClassName("vs-dialog-text").length > 0) {
          document.getElementsByClassName(
            "vs-dialog-text"
          )[0].innerHTML = `Do you want to delete below Branch?<br/><blockquote>Branch Name: <b>${rowData.item.data.branchName}</b></blockquote>`;
        }
      }, 0);
    });
  },
};
</script>
 <style scoped>
.digitelex-popup .vs-popup {
  width: 56vw;
}
</style>